import React, { Component } from "react";
import Popup from "react-popup";
export default class AvisoSocio extends Component {
  constructor(props) {
    super(props);
  }

  notifiPopup = (titulo, mensaje, mensaje2) =>

    Popup.register({
      title: titulo,
      content: <div className="popup">
        <div className="page">
          <div className="navbar">
            <div className="navbar-inner">
              <div className="title">Los servicios de CABAL Paraguay y Dimo Paraguay estarán temporalmente fuera de línea, por mantenimiento de base de datos, en la siguiente fecha y horario:  Martes 23/08/22, desde las 22:30h hasta las 23:30h.</div>
              <div className="right"><p>Los servicios que se podrian ver afectados son: Compra QR en comercios, Transferencias 24/7 (No así las transferencias SIPAP).</p>
              </div>
            </div>
          </div>
        </div>
      </div>,
      buttons: {
        right: [
          {
            text: "Cerrar",
            className: "secundary",
            action: function () {
              sessionStorage.setItem('mostrarAviso', true);
              Popup.close();
            },
          },

        ],
      },
    });
  getAviso() {
    var today = new Date();
    var end = new Date("Thu Aug 24 2022 00:00:00 GMT-0400 (GMT)");

    if (end > today) {
      Popup.queue(
        this.notifiPopup("Aviso al Socio")
      );
    }



  }




  render() {
    if (sessionStorage.getItem('mostrarAviso') == 'true') {
      // console.log("mostrar")
      return (
        <div></div>
      );
    } else {
      // console.log("nomostrar")
      return (
        <div>

          <div className="row">{this.getAviso()}</div>


        </div>
      );
    }

  }
}
